import Button from "../components/ui/Button";
import SectionHeading from "../components/ui/SectionHeading";
import AppCard from "../components/shared/AppCard";
import NoticeBanner from "../components/ui/NoticeBanner";
import PostCard from "../components/shared/PostCard";
import Seo from "../components/shared/Seo";
import StatCard from "../components/shared/StatCard";
import LoadingState from "../components/ui/LoadingState";
import { useSiteData } from "../app/SiteDataContext";
import useContentResource from "../hooks/useContentResource";
import { createPersonSchema, createWebsiteSchema } from "../seo/schema";
import { getHomepageFeed } from "../services/content/home.service";

function HomePage() {
  const { settings } = useSiteData();
  const siteProfile = settings.siteProfile;
  const homepageSections = settings.homepageSections;
  const featuredMetrics = settings.featuredMetrics || [];
  const homeFeed = useContentResource(
    ({ signal }) => getHomepageFeed({ signal }),
    []
  );
  const featuredApps = homeFeed.data?.featuredApps || [];
  const latestPosts = homeFeed.data?.latestPosts || [];

  return (
    <div className="page-stack">
      <Seo
        title="Frontend Architect & Product Builder"
        description="Premium React arayuzleri, headless CMS mimarisi, MyAppShop projeleri ve urun odakli blog icerikleri."
        path="/"
        schema={[createWebsiteSchema(), createPersonSchema(siteProfile)]}
        keywords={["kisisel web sitesi", "React mimarisi", "premium UI"]}
      />
      <section className="hero-grid">
        <div className="glass-panel hero-panel">
          <p className="eyebrow">Premium digital presence</p>
          <h1>{siteProfile.name}</h1>
          <h2>{siteProfile.role}</h2>
          <p className="hero-copy">{siteProfile.shortBio}</p>
          <div className="hero-pills">
            {homepageSections.heroHighlights.map((item) => (
              <span key={item} className="tag-pill">
                {item}
              </span>
            ))}
          </div>
          <div className="hero-actions">
            <Button to="/iletisim" variant="primary">
              {homepageSections.ctaPrimary}
            </Button>
            <Button to="/myappshop" variant="secondary">
              {homepageSections.ctaSecondary}
            </Button>
          </div>
        </div>

        <div className="stats-grid">
          {featuredMetrics.map((item) => (
            <StatCard key={item.label} item={item} />
          ))}
        </div>
      </section>

      <section className="content-section">
        <SectionHeading
          eyebrow="Featured Apps"
          title="Urun vitrini gibi davranan uygulama secimi"
          description="MyAppShop alaninda yer alan uygulamalardan premium deneyim diliyle hazirlanmis secmeler."
        />
        {homeFeed.usedFallback ? (
          <NoticeBanner>
            WordPress servisine ulasilamadi. Bu alan su anda local dummy veriyle
            gosteriliyor.
          </NoticeBanner>
        ) : null}
        {homeFeed.loading ? (
          <LoadingState title="One cikan uygulamalar yukleniyor..." />
        ) : (
          <div className="card-grid card-grid-two">
            {featuredApps.map((app) => (
              <AppCard key={app.id} app={app} />
            ))}
          </div>
        )}
      </section>

      <section className="content-section split-panel">
        <div className="glass-panel narrative-panel">
          <SectionHeading
            eyebrow="About"
            title="Tasarim ile muhendislik arasinda net bir urun dili kuruyorum"
            description={siteProfile.extendedBio}
          />
          <Button to="/hakkimda" variant="glass">
            Daha fazlasini oku
          </Button>
        </div>

        <div className="glass-panel cta-panel">
          <p className="eyebrow">Work together</p>
          <h3>Landing page, kisisel site, dashboard veya headless CMS altyapisi.</h3>
          <p>
            Markayi premium gosteren ama bakimi kolay kalan bir sistem kurmak
            icin birlikte calisabiliriz.
          </p>
          <Button to="/iletisim" variant="primary">
            Iletisim kur
          </Button>
        </div>
      </section>

      <section className="content-section">
        <SectionHeading
          eyebrow="Latest Writing"
          title="Blog tarafinda urun dusuncesi, frontend mimarisi ve premium UX"
          description="Icerik yapisi detay sayfalarina uygun, kartlar ise okunabilirlik ve kesif odakli."
        />
        {homeFeed.loading ? (
          <LoadingState title="Son yazilar yukleniyor..." />
        ) : (
          <div className="card-grid card-grid-three">
            {latestPosts.map((post) => (
              <PostCard key={post.id} post={post} />
            ))}
          </div>
        )}
      </section>
    </div>
  );
}

export default HomePage;
